import { render, staticRenderFns } from "./ProjectAccounting.vue?vue&type=template&id=972a5606&scoped=true"
import script from "./ProjectAccounting.vue?vue&type=script&lang=js"
export * from "./ProjectAccounting.vue?vue&type=script&lang=js"
import style0 from "./ProjectAccounting.vue?vue&type=style&index=0&id=972a5606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972a5606",
  null
  
)

export default component.exports